import { useTranslation } from "react-i18next";

import type { TicketStatus } from "@/lib/support";

const STYLES: Record<TicketStatus, string> = {
  open: "bg-sky-500/15 text-sky-300 border-sky-500/30",
  pending_agent: "bg-amber-500/15 text-amber-300 border-amber-500/30",
  pending_customer: "bg-slate-700/40 text-nb-text-2 border-slate-600/50",
  resolved: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  closed: "bg-slate-700/40 text-nb-text-2 border-slate-600/50",
};

export function TicketStatusPill({ status }: { status: TicketStatus }) {
  const { t } = useTranslation();
  return (
    <span
      className={
        "inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium " +
        (STYLES[status] ?? STYLES.closed)
      }
    >
      {t(`support.status.${status}`)}
    </span>
  );
}
